// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


import { getApigeeActive, getBffBaseUrl } from '@ps20-frontend/utils';

export const environment = {
  production: false,
  apigeeActive: getApigeeActive(),
  bffBaseUrl: getBffBaseUrl(),
};
